var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as Sentry from '@sentry/react';
var GAHelper = /** @class */ (function () {
    function GAHelper() {
    }
    GAHelper.pageView = function (page) {
        // if (window.dataLayer) {
        //     window.dataLayer.push({
        //         event: 'VirtualPageView',
        //         virtualPageURL: page
        //     })
        // }
        var _a;
        if (window.gtag) {
            window.gtag('set', 'page_path', page);
            // set utm_ settings from localStorage when its present
            if (sessionStorage) {
                var gtagSettings = JSON.parse((_a = sessionStorage.getItem('gtagSettings')) !== null && _a !== void 0 ? _a : '{}');
                if (gtagSettings === null || gtagSettings === void 0 ? void 0 : gtagSettings.content) {
                    window.gtag('set', 'campaign_content', gtagSettings.content);
                }
                if (gtagSettings === null || gtagSettings === void 0 ? void 0 : gtagSettings.source) {
                    window.gtag('set', 'campaign_source', gtagSettings.source);
                }
                if (gtagSettings === null || gtagSettings === void 0 ? void 0 : gtagSettings.medium) {
                    window.gtag('set', 'campaign_medium', gtagSettings.medium);
                }
            }
            window.gtag('event', 'page_view');
        }
    };
    GAHelper.transaction = function (order) {
        var _a;
        if (!window.dataLayer) {
            return;
        }
        try {
            var transactionProducts_1 = [];
            order.cart_items.forEach(function (item) {
                var key = null;
                // photobox
                if (3 === item.product_id) {
                    transactionProducts_1.push({
                        name: item.getName('en') + " (" + item.photos.length + " pictures)",
                        quantity: item.quantity,
                        price: item.getTotal(),
                    });
                    return;
                }
                transactionProducts_1.push({
                    name: item.getName('en') + " (" + item.photos.length + " pictures)",
                    quantity: item.quantity,
                    price: item.getTotal(),
                });
            });
            var payload = {
                event: 'OrderPlaced',
                currencyCode: (_a = order.currency) === null || _a === void 0 ? void 0 : _a.name,
                transactionId: order.id,
                transactionTotal: Number(order.getTotal()),
                transactionShipping: Number(order.shipping_fee),
                transactionProducts: __spreadArray([], transactionProducts_1),
            };
            window.dataLayer.push(payload);
        }
        catch (err) {
            Sentry.captureException(err);
        }
    };
    GAHelper.event = function (name, value) {
        if (!window.dataLayer) {
            return;
        }
        window.dataLayer.push({
            event: name,
            conversionValue: value,
        });
    };
    return GAHelper;
}());
export default GAHelper;
